import type { NDateLocale } from './enUS'
import { pt } from 'date-fns/locale'

const datePtPT: NDateLocale = {
  name: 'pt-PT',
  locale: pt
}

export default datePtPT
